<template>
  <v-select
    v-model="item"
    dir="rtl"
    :clearable="clearable"
    label="Title"
    :reduce="x => x.Id"
    :options="items"
    :loading="loading"
    :selectable="(option) => !option.isGroup"
    @open="onOpen"
  >

    <template slot="option" slot-scope="option">
      <div v-if="option && option.isGroup" class="v-select-group-label">
        {{ option.Title }}
      </div>
      <div v-else-if="option" style="padding-right: 1rem;">
        {{ option.Title }}
      </div>
    </template>

    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      موردی یافت نشد
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'ZOrderCategoryProcess',
  props: {
    value: {
      type: Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      val: this.value,
      loading: false,
    }
  },
  computed: {
    item: {
      get() {
        if (this.value) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  methods: {
    get() {
      if (this.items.length === 0) {
        this.loading = true
        this.$http.post(
          this.$api.ordercategoryprocess.getall, {},
        )
          .then(res => {
            this.items = this.flattenSteps(res.data)
            this.loading = false
          })
      }
    },
    onOpen() {
      this.get()
    },
    flattenSteps(data) {
      const result = []

      data.forEach(item => {
        // اضافه کردن دسته فقط اگر هنوز در لیست نیست
        const categoryExists = result.some(x => (x.Id === 'G-' + item.OrderCategory.Id) && (x.isGroup === true))
        if (!categoryExists) {
          result.push({
            Id: 'G-' + item.OrderCategory.Id,
            Title: item.OrderCategory.Title,
            isGroup: true,
          })
        }

        // اضافه کردن مرحله
        result.push({
          Id: item.Id,
          Title: item.Title,
          isGroup: false,
        })
      })

      return result
    },
  },
}
</script>

<style>
.v-select-group-label {
  font-weight: 600;
}
</style>
